import { NewLayoutPlacement } from '@neptune/shared/grid-layout-domain';

import type { Widget, WidgetType } from './core-widget-types';

export const ADD_WIDGET_MODAL_NAME = 'ADD_WIDGET_MODAL';

export type WidgetEditTarget = {
  type: 'dynamic-section';
  id: string;
};

export type AddWidgetModalData<T extends Widget = Widget> = {
  widget?: T;
  widgetPlacement?: NewLayoutPlacement;
  widgetType?: WidgetType;
  editTarget?: WidgetEditTarget;
  returnFocusTargetId?: string;
};
